import { createContext, useContext, useState, useEffect } from "react";
import { retrieve, store } from "../../../../../Services/localStorageService";

const TrackingContext = createContext();
const TRACKING_KEY = "live_tracked_trucks";

export const TrackingProvider = ({ children }) => {
  return (
    <TrackingContext.Provider>
      {children}
    </TrackingContext.Provider>
  );
};

export const useTracking = () => useContext(TrackingContext);
